import actions from './actions';
import { getItem } from '../../utils/localStorageControl';

const { LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_ERR, LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_ERR } = actions;

// Quién manda es el token, no la cookie `logedIn`. Esa cookie es de sesión:
// muere al cerrar el navegador mientras el token sigue en localStorage, y al
// volver a abrir quedaban en desacuerdo. Entonces ProtectedRoute veía el token
// y mandaba a /admin, App veía la cookie vacía y devolvía a /, y la pantalla se
// quedaba girando para siempre en el arranque. El caso espejo también existía:
// ProtectedRoute hace localStorage.clear() con un token caducado pero no borra
// la cookie. Con una sola fuente de verdad ninguno de los dos puede pasar.
const initState = {
  login: Boolean(getItem('access_token')),
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action:any) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
